//
import { getFetchDataFunction } from '../DataTableService'

//
import PurchaseInvoiceAppends from './PurchaseInvoiceAppends'
import PurchaseInvoiceIncludes from './PurchaseInvoiceIncludes'

//
const route = process.env.VUE_APP_API_ROUTE.concat('/pch_purchase_invoice')

//
export default getFetchDataFunction( route, PurchaseInvoiceIncludes, PurchaseInvoiceAppends )
